export const iconFontAwesomeEmojiFaceSadCry = (
	<i className="fa-solid fa-face-sad-cry"></i>
);
